// extracted by mini-css-extract-plugin
module.exports = {"Unauthorized":"PrivateRoute-module__Unauthorized___akRy-"};